// extracted by mini-css-extract-plugin
export default {"wrapper":"style--wrapper--8006fa","title":"style--title--6a9d57"};